import { ImageSize } from "@/components/Image";
import { TextSizeProps } from "@/components/Text";
import { ModalWidth } from "@/components/ui/alert-dialog";
import { OtpInputSize } from "@/components/ui/input-otp";

export const FONT_SIZE: Record<TextSizeProps, string> = {
  xs: "12px",
  sm: "18px",
  md: "24px",
  lg: "30px",
  xl: "36px",
};

export const IMAGE_SIZE: Record<ImageSize, string> = {
  xxs: "18px",
  xs: "24px",
  sm: "34px",
  md: "44px",
  lg: "54px",
  xl: "64px",
  flex: "100%",
};

export const MODAL_WIDTH: Record<ModalWidth, string> = {
  sm: "40%",
  md: "60%",
  lg: "80%",
};

export const OTP_INPUT_SIZE: Record<OtpInputSize, string> = {
  sm: "36px",
  lg: "64px",
};
